export interface OktaLoginRequest {
  username?: string;
  password?: string;
  id?: string;
  token?: string;
}

export interface forgotPasswordType {
  // agencyid: string;
  email: string;
}
export interface resetPasswordType {
  SessionID: string;
  Password: string;
  //confirmPassword: string;
}

export interface updateEmailType {
  ExistingPassword: string;
  Email: string;
  AgentContactId: string;  
  OldEmail: string;
}

export interface updatePhoneType {
  Phone: string;
  AgentContactId: string;  
}

export interface updatePasswordType {
  AgentContactId: string;
  UserName: string;
  ExistingPassword: string;
  OldPassword: string;
  NewPassword: string;
  GsaAgentID: number;
}


export interface userFeatureRequest {
  
  UserName: string;

}

export interface validateSessionIdType {
  sid: string;
  logininfo: string;
}
